import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { isPlatform, LoadingController, ModalController } from '@ionic/angular';

@Component({
  selector: 'app-login-modal',
  templateUrl: './login-modal.page.html',
  styleUrls: ['./login-modal.page.scss'],
})
export class LoginModalPage implements OnInit {
  isWeb = false;
  credentials: FormGroup;

  constructor(private modalCtrl: ModalController,
    private fb: FormBuilder,
    private loadingController: LoadingController) { }

  ngOnInit() {
    this.isWeb = isPlatform('desktop');

    this.credentials = this.fb.group({
      email: ['saimon@devdactic.com', [Validators.required, Validators.email]],
      password: ['123456', [Validators.required, Validators.minLength(6)]],
    });
  }

  async login() {
    const loading = await this.loadingController.create({
      duration: 2000
    });
    await loading.present();

    setTimeout(() => {
      this.close();
    }, 2000);  
  }

  get email() {
    return this.credentials.get('email');
  }
  
  get password() {
    return this.credentials.get('password');
  }

  close() {
    this.modalCtrl.dismiss();
  }
}
